import { APIProvider } from '@vis.gl/react-google-maps';
import React, { useEffect, useState } from "react";
import GoogleSearchInput from "components/Search_Google/GoogleSearchInput";
import useAsyncFn from "react-use/lib/useAsyncFn";
import logNewSearchSubmit from "lib/ga/newSearchSubmit";
import getSearchSuggestions from "lib/getSearchSuggestionsNew";
import useDebounce from "react-use/lib/useDebounce";
import logEvent from "lib/ga/miscEvent";
import { useRouter } from "next/navigation";
import styles from './categorySearch.module.css';
const getSchemeItemUri = (item) => `/scheme/${item.uri.toLocaleLowerCase()}-${item.id}`

type Search = {
    type: string,
    forSale: boolean,
    nameLookUp: boolean,
    categoryUrl: string | null | undefined,
    category: string,
    placeholder: string
}

const Search = ({ type = 'PROPERTY', forSale = false, nameLookUp = true, categoryUrl = null, category, placeholder }: Search) => {
    const [criteria, setCriteria] = useState('LOCATION');
    const [inputValue, setInputValue] = useState('');
    const [activeSuggestion, setActiveSuggestion] = useState(0);
    //for scheme name search
    const [suggestions, setSuggestions] = useState([]);
    const [nameUri, setNameUri] = useState(null);
    const [isRedirecting, setisRedirecting] = useState(false);
    const [isSearching, setisSearching] = useState(false);

    const [isLoaded, setIsloaded] = useState(false);
    let router = useRouter();
    //for scheme name redirect
    useEffect(() => {

        if (nameUri) {
            setisRedirecting(true);

            logEvent({
                category: "Search",
                action: "User made a search",
                label: nameUri,
            });
            logNewSearchSubmit({
                type: type,
                category: "Search",
                criteria: criteria,
                url: nameUri,
            });

            router.push(nameUri);
        } else {
            setisRedirecting(false)
        }

    }, [nameUri]);

    const [suggestionsState, fetchSuggestions] = useAsyncFn(
        async () => {
            if (!inputValue) return;

            setisSearching(true);

            const newSuggestions = await getSearchSuggestions(inputValue, 'scheme', category);

            setSuggestions(newSuggestions);
            setisSearching(false);
        },
        // Variables need to be defined here in order to be used in the async function. If not defined they will exist with their initial value.
        [inputValue]
    );
    const sendQuery = () => {
        // make async call for suggestions
        fetchSuggestions();
    };

    const [libraries] = useState(['places']);

    const [debounceState, cancelDebounce] = useDebounce(
        // The fucntion to call after the debounce period
        () => {
            if (!isRedirecting) {
                sendQuery();
            }

        },
        // The period we wait
        500,
        // The depenndencies whose changes we react to to trigger the debounce. (Same as useEffect)
        [inputValue, isRedirecting]
    );



    return (
        <div className={styles.googleSearchContainer}>
            <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_APIS_KEY_CSR} onLoad={() => setIsloaded(true)}>
                {criteria == "LOCATION" && isLoaded &&
                    <GoogleSearchInput type={type} forSale={forSale} category={categoryUrl} />
                }
                {criteria === "LOCATION" && !isLoaded &&
                    <div className={styles.googleSearchContainer}><input id="google-search-input" type="text" placeholder="Search by city, town, street or postcode" autoComplete="off" /></div>
                }
            </APIProvider>
            {
                criteria === 'NAME' && (
                    <input
                        id="name-search"
                        value={inputValue}
                        type="text"
                        placeholder={placeholder}
                        autoComplete="off"
                        onChange={(e) => {
                            setInputValue(e.target.value);
                            setActiveSuggestion(0)
                        }}
                        onKeyDown={(e) => {
                            if (e.key == "ArrowDown") {
                                let newIndex = activeSuggestion + 1;
                                if (newIndex >= 5) {
                                    newIndex = 0;
                                }
                                setActiveSuggestion(newIndex);
                            }
                            if (e.key == "ArrowUp") {
                                let newIndex = activeSuggestion - 1;
                                if (newIndex < 0) {
                                    newIndex = 4;
                                }
                                setActiveSuggestion(newIndex);
                            }
                            if (e.key == "Enter") {
                                let item = suggestions[activeSuggestion];
                                // CR-1369
                                if (item) {
                                    setNameUri(getSchemeItemUri(item));
                                    setInputValue(item.name);
                                    setisRedirecting(true);
                                }
                            }
                        }}
                        disabled={isRedirecting}
                    />
                )
            }
            <div className={styles.criteriaTabs}>
                {!nameLookUp && (
                    <button disabled className={styles.active}> {forSale ? 'For Sale' : 'For Rent'}</button>
                )}
                {
                    nameLookUp && (
                        <>
                            <button onClick={(e) => {
                                e.preventDefault();
                                setCriteria("LOCATION");
                            }}
                                id="location"
                                className={`${criteria === "LOCATION" ? styles.active : ""}`} >Location</button>
                            <button onClick={(e) => {
                                e.preventDefault();
                                setCriteria("NAME");
                            }}
                                id="name"
                                className={`${criteria === "NAME" ? styles.active : ""}`}>Name</button>
                        </>
                    )
                }
            </div>
            {criteria == "NAME" && <ul className={styles.suggestions}>
                {suggestions.length > 0 && !isRedirecting &&
                    suggestions.map((item, index) => (
                        <li className={styles.suggestion}
                            isActive={index == activeSuggestion}
                            key={`${item.id}${index}`}
                            onClick={() => {
                                setNameUri(getSchemeItemUri(item));
                                setInputValue(item.name);
                                setisRedirecting(true);
                            }}
                        >
                            {item.name}
                        </li>
                    ))}
            </ul>}
        </div>
    )
}


export default Search;
